module.exports = __webpack_public_path__ + "static/media/bg2.d7f8d013.png";